import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const BusinessNetworkList = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/businessnetwork?page=${currentPage}&pincode=${searchQuery}`);
      console.log(response.data.businessNetwork);
      setCategories(response.data.businessNetwork);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (id) => {
    history.push(`/editBusinessNetwork/${id}`);
  };


  
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/businessnetwork/${id}`);
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDownload = () => {
    const fields = [
      "id", "title", "category.name","city","pincode", "description", "createdAt"
  ];
  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(categories);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'businessNetwork_list.csv');
}


const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};
const formatDescription = (description) => {
  return description.length > 10 ? description.slice(0, 10) + '...' : description;
};

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Business Network List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Pincode"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div>
          <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Category Name</th>
                <th>City</th>
                <th>Pincode</th>
                <th>Description</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, index) => {
                return (
                  <tr key={category.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{category?.title}</td>
                    <td>{category?.category?.name}</td>
                    <td>{category?.city}</td>
                    <td>{category?.pincode}</td>
                    <td>{formatDescription(category.description)}</td>
                    <td> {formatDate(category.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(BusinessNetworkList);
